import * as React from 'react';
import { BaSeInput, BaSeCheckbox, BaSeGrid, BaSeGridItem } from '@base/react';
import { LabelTitle } from '../components/LabelTitle';

const numberMask = (val) => {
  if (!val) return '';
  const cleaned = val.replace(/\D/g, '');
  const parsed = parseInt(cleaned, 10);
  return isNaN(parsed) ? cleaned : parsed;
};

export const DurationSection = ({
  formData,
  availableOptions,
  isCompleteForm,
  onFieldChange,
  onToggleCheckbox,
  setFormData,
}) => {
  return (
    <>
      <BaSeGrid>
        <BaSeGridItem tablet={{ size: 5 }} mobile={{ size: 12 }}>
          <div style={{ alignSelf: 'flex-end' }}>
            <BaSeInput
              label="Carga horária"
              placeholder="xx horas"
              value={formData.cargaHoraria}
              onChange={(e) => onFieldChange('cargaHoraria', e, numberMask)}
              onBlur={() =>
                setFormData((prev) => ({
                  ...prev,
                  cargaHoraria: prev.cargaHoraria
                    ? prev.cargaHoraria + ' horas'
                    : '',
                }))
              }
              onFocus={() =>
                setFormData((prev) => ({
                  ...prev,
                  cargaHoraria: numberMask(prev.cargaHoraria),
                }))
              }
            />
          </div>
        </BaSeGridItem>
        {isCompleteForm && (
          <>
            <BaSeGridItem tablet={{ size: 6 }} mobile={{ size: 12 }}>
              <BaSeInput
                label="Tempo para realização"
                placeholder="xx dias"
                value={formData.tempoRealizacao}
                onChange={(e) =>
                  onFieldChange('tempoRealizacao', e, numberMask)
                }
                onBlur={() =>
                  setFormData((prev) => ({
                    ...prev,
                    tempoRealizacao: prev.tempoRealizacao
                      ? prev.tempoRealizacao + ' dias'
                      : '',
                  }))
                }
                onFocus={() =>
                  setFormData((prev) => ({
                    ...prev,
                    tempoRealizacao: numberMask(prev.tempoRealizacao),
                  }))
                }
              />
            </BaSeGridItem>
            <BaSeGridItem tablet={{ size: 4 }} mobile={{ size: 12 }}>
              <BaSeInput
                label="Valor"
                subLabel="Opcional"
                placeholder="R$ 0,00"
                mask="decimal"
                value={formData.valor}
                onChange={(e) => onFieldChange('valor', e)}
              />
            </BaSeGridItem>
          </>
        )}
      </BaSeGrid>
      {isCompleteForm && (
        <div>
          <LabelTitle
            label="Funcionalidades"
            subTitle="Selecione as funcionalidades que esse produto oferece"
          />
          <BaSeGrid>
            {availableOptions.funcionalidades?.map((item, key) => (
              <BaSeGridItem
                tablet={{ size: key === 2 ? 6 : key === 1 ? 3 : 3 }}
                key={item?.id}
              >
                <BaSeCheckbox
                  align="top-left"
                  color="default"
                  size="medium"
                  label={item?.nome}
                  checked={item?.id in (formData.funcionalidades ?? {})}
                  onChange={() => onToggleCheckbox(item.id, 'funcionalidades')}
                />
              </BaSeGridItem>
            ))}
          </BaSeGrid>
        </div>
      )}
    </>
  );
};
